export const translations = {
  es: {
    nav: {
      services: "Servicios",
      value: "Cómo trabajamos",
      process: "Proceso",
      about: "Quiénes somos",
      contact: "Contacto",
      cta: "Hablemos",
    },
    hero: {
      overline: "BlueBrotherstech · Software para tu negocio",
      title:
        "Software a medida para que tu negocio funcione mejor cada día.",
      subtitle:
        "Acompañamos a pequeños comercios, restaurantes y pymes que quieren digitalizar su día a día sin complicarse la vida. Y cuando otros equipos técnicos necesitan una segunda opinión, también hacemos auditorías y consultoría puntual.",
      primaryCta: "Cuéntanos tu caso",
      secondaryCta: "Ver servicios",
      metric1: "Cercanía",
      metric1Label: "hablas con quien construye tu software",
      metric2: "A medida",
      metric2Label: "adaptado a cómo trabajas tú, no al revés",
      metric3: "Sin sorpresas",
      metric3Label: "presupuestos y plazos acordados por escrito",
    },
    services: {
      overline: "Servicios",
      title: "Lo que podemos hacer por tu negocio.",
      subtitle:
        "Desde la primera web o sistema de gestión hasta auditorías técnicas para equipos que necesitan criterio externo.",
      items: [
        {
          title: "Software a medida",
          desc: "Aplicaciones web y herramientas internas pensadas para tu forma de trabajar: reservas, pedidos, gestión de clientes, control de stock o lo que tu negocio necesite resolver.",
        },
        {
          title: "Soluciones SaaS",
          desc: "Plataformas en la nube listas para usar y configurables para tu sector: pequeñas cadenas de hostelería, comercios, servicios profesionales y proyectos B2B.",
        },
        {
          title: "Integraciones",
          desc: "Conectamos tu TPV, tu ERP, tu pasarela de pago o las herramientas que ya usas para que dejen de funcionar como islas y empiecen a hablar entre sí.",
        },
        {
          title: "Auditorías técnicas",
          desc: "Revisión externa de tu código, arquitectura o infraestructura. Te decimos con claridad qué está bien, qué riesgos hay y por dónde empezar a mejorar.",
        },
      ],
    },
    value: {
      overline: "Cómo trabajamos",
      title:
        "Trabajamos como un socio técnico cercano, no como un proveedor más.",
      subtitle:
        "Nos sentamos contigo, entendemos el negocio y construimos solo lo que aporta valor. Sin lenguaje técnico innecesario y sin cobrar por funciones que no vas a usar.",
      points: [
        {
          title: "Trato directo",
          desc: "Hablas siempre con la misma persona, y esa persona conoce tu proyecto al detalle. Nada de cadenas largas ni intermediarios.",
        },
        {
          title: "Presupuestos claros",
          desc: "Acordamos alcance, precio y plazos por escrito antes de empezar. Si algo cambia, te lo decimos antes de tocarlo.",
        },
        {
          title: "Pensado para quien lo usa",
          desc: "Diseñamos las herramientas pensando en tu equipo y tus clientes, no en lucirnos con tecnología que no necesitas.",
        },
      ],
    },
    process: {
      overline: "Cómo lo hacemos",
      title: "Un proceso pensado para que no te sorprenda nada.",
      subtitle:
        "Cuatro fases sencillas para que en cada momento sepas en qué punto estamos y qué viene después.",
      steps: [
        {
          n: "01",
          title: "Entendemos tu negocio",
          desc: "Charlamos sin prisa para entender cómo trabajas hoy, qué te quita tiempo y dónde el software puede ayudarte de verdad.",
        },
        {
          n: "02",
          title: "Construimos por fases",
          desc: "Empezamos por lo más importante y lo enseñamos pronto. Así puedes probarlo, opinar y ajustar antes de seguir adelante.",
        },
        {
          n: "03",
          title: "Validamos contigo",
          desc: "Cada entrega pasa por revisiones técnicas y, sobre todo, por las personas que van a usar la herramienta cada día.",
        },
        {
          n: "04",
          title: "Lanzamos y acompañamos",
          desc: "Te ayudamos a poner en marcha el software, formar a tu equipo y seguimos disponibles para mejoras y soporte.",
        },
      ],
    },
    about: {
      overline: "Sobre BlueBrotherstech",
      title: "Un pequeño estudio de software con vocación de cercanía.",
      paragraph1:
        "BlueBrotherstech nació para ayudar a comercios, restaurantes y pymes a aprovechar el software sin tener que convertirse en expertos en tecnología. Diseñamos y construimos las herramientas que necesitas para operar mejor, vender más y dormir tranquilo.",
      paragraph2:
        "También colaboramos con otros equipos cuando necesitan una mirada externa: auditorías de código, revisiones de arquitectura o acompañamiento técnico puntual. Equipo pequeño, criterio técnico y trato directo.",
      stats: [
        { value: "Cercanía", label: "atención directa con quien construye" },
        { value: "Foco pyme", label: "soluciones a la medida del negocio real" },
        { value: "Transparencia", label: "construimos la solución contigo, lista para reutilizarse y escalar" },
      ],
    },
    cta: {
      overline: "Empieza la conversación",
      title: "Cuéntanos qué necesita tu negocio.",
      subtitle:
        "Escríbenos sin compromiso. Te respondemos personalmente, vemos si encajamos y te decimos con honestidad si podemos ayudarte.",
      primary: "Escribir a support@bluebrotherstech.com",
      secondary: "support@bluebrotherstech.com",
    },
    footer: {
      tagline: "Software hecho para negocios reales.",
      sections: {
        company: "Empresa",
        services: "Servicios",
        contact: "Contacto",
      },
      links: {
        about: "Quiénes somos",
        process: "Proceso",
        services: "Servicios",
        custom: "Software a medida",
        saas: "SaaS",
        integrations: "Integraciones",
        consulting: "Auditorías",
      },
      rights: "Todos los derechos reservados.",
    },
    common: {
      langLabel: "Idioma",
      valueOverlay: "Estudio de software · Cerca de tu negocio",
    },
    seo: {
      title: "BlueBrotherstech — Software a medida y SaaS para pymes",
      description:
        "Estudio de software a medida y soluciones SaaS para pequeños comercios, restaurantes y pymes. También auditorías técnicas y consultoría puntual.",
      ogLocale: "es_ES",
      htmlLang: "es",
    },
  },
  en: {
    nav: {
      services: "Services",
      value: "How we work",
      process: "Process",
      about: "About",
      contact: "Contact",
      cta: "Let's talk",
    },
    hero: {
      overline: "BlueBrotherstech · Software for your business",
      title:
        "Custom software that makes your day-to-day business work better.",
      subtitle:
        "We help small shops, restaurants and SMBs digitalise their daily operations without the headaches. When other technical teams need a second opinion, we also run audits and provide focused consulting.",
      primaryCta: "Tell us about your case",
      secondaryCta: "See services",
      metric1: "Close partner",
      metric1Label: "you talk to the person building your software",
      metric2: "Tailored",
      metric2Label: "shaped around how you work, not the other way around",
      metric3: "No surprises",
      metric3Label: "scope, price and dates agreed in writing",
    },
    services: {
      overline: "Services",
      title: "What we can do for your business.",
      subtitle:
        "From a first website or management tool, to technical audits for teams that need an external point of view.",
      items: [
        {
          title: "Custom software",
          desc: "Web applications and internal tools designed around the way you work: bookings, orders, customer management, stock control or anything your business needs to solve.",
        },
        {
          title: "SaaS solutions",
          desc: "Cloud platforms ready to use and configurable to your sector: small hospitality groups, retail, professional services and B2B projects.",
        },
        {
          title: "Integrations",
          desc: "We connect your POS, ERP, payment gateway or the tools you already use, so they stop working as islands and start talking to each other.",
        },
        {
          title: "Technical audits",
          desc: "External review of your code, architecture or infrastructure. We tell you clearly what is fine, what the real risks are and where to start improving.",
        },
      ],
    },
    value: {
      overline: "How we work",
      title:
        "We work as a close technical partner, not as just another supplier.",
      subtitle:
        "We sit down with you, understand the business and build only what adds value. No unnecessary jargon and no charging for features you'll never use.",
      points: [
        {
          title: "Direct contact",
          desc: "You always talk to the same person, and that person knows your project inside out. No long chains, no middlemen.",
        },
        {
          title: "Clear pricing",
          desc: "We agree on scope, price and timeline in writing before we start. If anything changes, we tell you before touching it.",
        },
        {
          title: "Built for the people using it",
          desc: "We design tools around your team and your customers, not to show off technology you don't need.",
        },
      ],
    },
    process: {
      overline: "How we do it",
      title: "A process designed so nothing catches you by surprise.",
      subtitle:
        "Four simple phases so you always know where we are and what comes next.",
      steps: [
        {
          n: "01",
          title: "We understand your business",
          desc: "We take the time to understand how you work today, what eats your time and where software can actually help you.",
        },
        {
          n: "02",
          title: "We build in stages",
          desc: "We start with what matters most and show it early. That way you can try it, give feedback and adjust before we keep going.",
        },
        {
          n: "03",
          title: "We validate it with you",
          desc: "Every release goes through technical reviews and, above all, the people who will actually use the tool every day.",
        },
        {
          n: "04",
          title: "We launch and stick around",
          desc: "We help you roll the software out, train your team and stay available for improvements and support.",
        },
      ],
    },
    about: {
      overline: "About BlueBrotherstech",
      title: "A small software studio that values being close to clients.",
      paragraph1:
        "BlueBrotherstech was born to help shops, restaurants and SMBs take advantage of software without having to become technology experts. We design and build the tools you need to operate better, sell more and sleep at night.",
      paragraph2:
        "We also work with other teams when they need an external view: code audits, architecture reviews or focused technical support. A small team, strong technical judgement and direct conversations.",
      stats: [
        { value: "Closeness", label: "direct contact with the people building it" },
        { value: "SMB focus", label: "solutions tailored to real, everyday businesses" },
        { value: "Transparency", label: "we build the solution with you, ready to be reused and scaled" },
      ],
    },
    cta: {
      overline: "Start the conversation",
      title: "Tell us what your business needs.",
      subtitle:
        "Send us a note, no strings attached. We reply personally, see if we're a fit and tell you honestly whether we can help.",
      primary: "Email support@bluebrotherstech.com",
      secondary: "support@bluebrotherstech.com",
    },
    footer: {
      tagline: "Software made for real businesses.",
      sections: {
        company: "Company",
        services: "Services",
        contact: "Contact",
      },
      links: {
        about: "About us",
        process: "Process",
        services: "Services",
        custom: "Custom software",
        saas: "SaaS",
        integrations: "Integrations",
        consulting: "Audits",
      },
      rights: "All rights reserved.",
    },
    common: {
      langLabel: "Language",
      valueOverlay: "Software studio · Close to your business",
    },
    seo: {
      title: "BlueBrotherstech — Custom software & SaaS for small businesses",
      description:
        "Custom software studio and SaaS solutions for small shops, restaurants and SMBs. Plus technical audits and focused consulting.",
      ogLocale: "en_US",
      htmlLang: "en",
    },
  },
};
